import { render, staticRenderFns } from "./TherapyArea.vue?vue&type=template&id=7f482295&"
import script from "./TherapyArea.vue?vue&type=script&lang=js&"
export * from "./TherapyArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports